<article class="file-claim-start workerscomp-box-info" *ngIf="lineOfBusiness === 'Workers Compensation'">
    <h2 class="bold-text">Here’s what you can expect</h2>
    <ul>
        <li><span>Filing takes just a few minutes.</span></li>
        <li><span>We'll follow up with you to answer any questions you may have, usually by the end of the next business day.</span></li>
        <li><span>If our claim volume increases due to severe weather or other events, our response may take from 3-5 days.</span></li>
    </ul>
    <hr>
    <span>We can better serve you by phone, at 1-800-421-3535, if your claim involves the following:</span>
    <ul>
        <li><span>Fatality</span></li>
        <li><span>Severe injuries</span></li>
    </ul>
</article>

<article class="file-claim-start general-liability-box-info" *ngIf="lineOfBusiness === 'General Liability'">
    <h2 class="bold-text">Here’s what you can expect</h2>
    <ul>
        <li><span>Filing takes just a few minutes.</span></li>
        <li><span>We'll follow up with you to answer any questions you may have, usually by the end of the next business day.</span></li>
        <li><span>If our claim volume increases due to severe weather or other events, our response may take from 3-5 days.</span></li>
    </ul>
    <hr>
    <span>Please call us at 1-800-421-3535 if your claim involves any of these situations:</span>
    <ul>
        <li><span>Fatality or severe injuries</span></li>
        <li><span>Significant damages</span></li>
    </ul>
</article>

<article class="file-claim-start auto-box-info" *ngIf="lineOfBusiness === 'Commercial Auto'">
    <h2 class="bold-text">Here’s what you can expect</h2>
    <ul>
        <li><span>Filing takes just a few minutes.</span></li>
        <li><span>We'll follow up with you to answer any questions you may have, usually by the end of the next business day.</span></li>
        <li><span>If our claim volume increases due to severe weather or other events, our response may take from 3-5 days.</span></li>
    </ul>
    <hr>
    <span>For <span class="bold-text">towing reimbursement</span>, call us anytime at 1-800-421-3535.</span>
    <hr>
    <span>
        For <span class="bold-text">glass or windshield claims</span>, we work closely with Safelite AutoGlass®. Call 1-800-421-3535
        and state "glass only" to file your claim anytime.
    </span>
</article>

<article class="file-claim-start property-box-info" *ngIf="lineOfBusiness === 'Commercial Property'">
    <h2 class="bold-text">Here’s what you can expect</h2>
    <ul>
        <li><span>Filing takes just a few minutes.</span></li>
        <li><span>We'll follow up with you to answer any questions you may have, usually by the end of the next business day.</span></li>
        <li><span>If our claim volume increases due to severe weather or other events, our response may take from 3-5 days.</span></li>
        <li><span>Depending on the extent of the damage, your property, may need to be inspected to estimate damages.</span></li>
    </ul>
    <hr>
    <span>Please call us if your claim involves any of these situations:</span>
    <ul>
        <li><span>Injury or fatality to anyone involved</span></li>
        <li><span>Someone else's property was damaged</span></li>
        <li><span>Significant building damage that prevents you from conducting business</span></li>
    </ul>
    <br><span>Call us anytime at 1-800-421-3535.</span>
</article>